import { Tag } from 'antd';

interface ScoreBadgeProps {
  score: number | null | undefined;
  /** Scale max (config-driven on the backend; default 100). */
  max?: number;
}

/** Quality score with a Low/Medium/High band. Higher is better. */
export default function ScoreBadge({ score, max = 100 }: ScoreBadgeProps) {
  if (score == null) return <Tag>—</Tag>;

  const ratio = max > 0 ? score / max : 0;
  const { color, label } =
    ratio >= 0.75
      ? { color: 'green', label: 'خوب' }
      : ratio >= 0.5
        ? { color: 'gold', label: 'متوسط' }
        : { color: 'red', label: 'ضعیف' };

  return (
    <Tag color={color}>
      {score} / {max} · {label}
    </Tag>
  );
}
